import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8619c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weeek-tags-item__block" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "weeek-tags-item__parameter-option" }

import GetAttributeTagOptionsResponseItem from "@/api/Weeek/dataSource/api/project-manager/weeek/i-services/models/response/GetAttributeTagOptionsResponseItem";
import { TaskParameter, TaskParameterTypeEnum } from "@/components";
import { TagModel } from "@/components/task-forms/models";
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmInput,
  TirPmMultiselect,
  TirPmSelect,
} from "tir-components";
import { ArrowPathIcon, TrashIcon } from "tir-style-system/icons/outline";
import { computed, onMounted, PropType, ref, watch } from "vue";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'weeek-tags-item',
  props: {
  /**индекс статуса */
  index: { type: Number },
  /**Данные статусов weeek */
  tagsDataWeeek: { type: Array as PropType<GetAttributeTagOptionsResponseItem[]> },
  /**Статус weeek */
  tagDataWeeek: { type: Object as PropType<GetAttributeTagOptionsResponseItem> },
  /**Теги проекта ПМ */
  tagsProjectPm: { type: Array as PropType<TagModel[]> },
},
  emits: ["searchTags"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Выбранный тег */
const selectedTag = ref<TagModel[]>([]);

watch(
  () => props.tagsProjectPm,
  () => {
    if (!selectedTag.value.length) {
      selectedTag.value = props.tagsProjectPm.find((tag) => tag.Id === props.tagDataWeeek?.TagId)
        ? [props.tagsProjectPm.find((tag) => tag.Id === props.tagDataWeeek?.TagId)!]
        : [];
    }
  },
  { immediate: true },
);

/**Выбрать тег */
const selectTag = (tag: TagModel) => {
  props.tagDataWeeek.TagId = tag.Id;
};
/**Удаление тега */
const removeTagsWeeek = (index: number) => {
  props.tagsDataWeeek.splice(index, 1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmInput), {
      class: "weeek-tags-item__input",
      label: "Статус с weeek.ru",
      isWithHint: false,
      modelValue: __props.tagDataWeeek.WeeekTagName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.tagDataWeeek.WeeekTagName) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(ArrowPathIcon), { class: "weeek-tags-item__icon" }),
    _createVNode(_unref(TirPmMultiselect), {
      isSearchLocal: false,
      "selected-options": selectedTag.value,
      options: __props.tagsProjectPm,
      showOnHover: "",
      popoverWidth: "30rem",
      popoverClasses: "weeek-tags-item__popover",
      label: "Тег на замену",
      searchInputLabel: "Поиск по тегам",
      class: "weeek-tags-item__multiselect",
      noTeleport: "",
      disableContentBlur: "",
      onUpdateSearch: _cache[1] || (_cache[1] = ($event: any) => (emit('searchTags', $event))),
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (emit('searchTags', $event)))
    }, {
      optionList: _withCtx(({ option }) => [
        _createElementVNode("div", {
          class: "weeek-tags-item__parameter-option-block",
          onClick: ($event: any) => (selectTag(option))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(TaskParameter), {
              data: option,
              type: _unref(TaskParameterTypeEnum).Tag,
              "hide-remove": "",
              preview: ""
            }, null, 8, ["data", "type"])
          ])
        ], 8, _hoisted_2)
      ]),
      selectedContent: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTag.value, (tag) => {
          return (_openBlock(), _createElementBlock("div", {
            key: __props.index,
            class: "weeek-tags-item__parameter"
          }, [
            _createVNode(_unref(TaskParameter), {
              data: tag,
              type: _unref(TaskParameterTypeEnum).Tag,
              "hide-remove": "",
              preview: ""
            }, null, 8, ["data", "type"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["selected-options", "options"]),
    _createVNode(_unref(TirPmButton), {
      variant: _unref(TirPmButtonVariantEnum).LinkState,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (removeTagsWeeek(__props.index)))
    }, {
      leftSlot: _withCtx(() => [
        _createVNode(_unref(TrashIcon), { class: "weeek-tags-item__icon-trash" })
      ]),
      _: 1
    }, 8, ["variant"])
  ]))
}
}

})